import { graphQlClient } from "lib/graphql-client.js";
import React, { useContext } from "react";
import { gql } from "@apollo/client";

import { CurrencyContext } from "contexts/currency";

// import { getServerState } from "react-instantsearch-hooks-server";

import Head from "next/head";
// const Layout = dynamic(() => import("../../components/Layout"), { ssr: false });
import Layout from "../../components/Layout";
import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";

// const ExperiencePresentation = dynamic(
//   () => import("components/ExperiencePresentation/ExperiencePresentation"),
//   { loading: () => <PageLoader /> }
// );
import ExperiencePresentation from "components/ExperiencePresentation/ExperiencePresentation";

import { site, API_URL } from "config";

const ExperienceFront = ({ pageData, url, seo, layoutData }) => {
  const currencyContext = useContext(CurrencyContext);
  const currency = currencyContext.currency ?? {
    fullName: "United States Dollar",
    code: "usd",
    symbolCode: 36,
    symbol: "$",
  };

  const SEO = {
    ...seo,
    canonicalURL: site + "/experiences",
  };

  return (
    <>
      <Head>
        <link
          crossOrigin="true"
          href="https://Z3P5U8M6XJ-dsn.algolia.net"
          rel="preconnect"
        />
      </Head>
      <Layout seo={SEO} showEmailSignup={false} layoutData={layoutData}>
        <div className="variable-container">
          <ExperiencePresentation
            // serverState={serverState}
            // url={url}
            currency={currency}
            seo={SEO}
          />
        </div>
      </Layout>
    </>
  );
};

export default ExperienceFront;

export async function getStaticProps() {
  const strapiApolloClient = graphQlClient();

  let experiencesResponse = await strapiApolloClient.query({
    query: gql`
      query ExperiencesQuery {
        experiencePage {
          data {
            attributes {
              search_engine_optimization {
                id
                metaTitle
                metaDescription
                meta {
                  id
                  title
                  content
                }
                preventIndexing
                metaMedia {
                  data {
                    attributes {
                      url
                      alternativeText
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  });

  const search_engine_optimization =
    experiencesResponse?.data?.experiencePage?.data?.attributes
      ?.search_engine_optimization;

  const seo = {
    ...search_engine_optimization,
    metaMedia: search_engine_optimization?.metaMedia?.data?.attributes,
  };

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: {
      seo: seo,
      layoutData,
    },
  };
}
